/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Band_EyebrowInputs */

const en_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const zh_hans1_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

const pt_br2_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dúvidas frequentes`)
};

const es_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const fr_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const de_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const ru_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы и ответы`)
};

const it_faq_band_eyebrow = /** @type {(inputs: Faq_Band_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Faq_Band_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const faq_band_eyebrow = /** @type {((inputs?: Faq_Band_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Band_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_faq_band_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_faq_band_eyebrow(inputs)
	if (locale === "es") return es_faq_band_eyebrow(inputs)
	if (locale === "fr") return fr_faq_band_eyebrow(inputs)
	if (locale === "de") return de_faq_band_eyebrow(inputs)
	if (locale === "ru") return ru_faq_band_eyebrow(inputs)
	if (locale === "it") return it_faq_band_eyebrow(inputs)
	return en_faq_band_eyebrow(inputs)
});